
<template>
    <GoogleMap
        v-if="googleMapsApiKey"
        :api-key="googleMapsApiKey"
        :map-id="mapId"
        style="width: 100%; height: 100%"
        :center="center"
        disable-default-ui
        :zoom="zoom"
    >


        <AdvancedMarker :options="markerOptions" :pin-options="pinOptions" />
    </GoogleMap>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { GoogleMap, AdvancedMarker } from "vue3-google-map";

// defineProps must run at top-level in <script setup>
const props = defineProps({
    lat: { type: Number, required: true },
    lng: { type: Number, required: true },
    zoom: { type: Number, default: 13 },
    mapId: { type: String, default: "43ce5541f9ab16b272098643" },
});

// reactive store for API key
const googleMapsApiKey = ref(null);

// pull it from your <meta> tag once mounted
onMounted(() => {
    const meta = document.querySelector('meta[name="google-maps-api-key"]');
    if (meta) googleMapsApiKey.value = meta.content;
});

// computed center & marker options
const center = computed(() => ({ lat: props.lat, lng: props.lng }));
const markerOptions = computed(() => ({ position: center.value }));
const pinOptions = {
    background: "#00617f",
    borderColor: "#00617f",
    glyphColor: "#ffffff",
};
</script>
